(function () {
    'use strict';

    angular
        .module('core.services')
        .service('MeService', MeService)

    /** @ngInject */
    function MeService(HttpService) {
        const MeService = {
            getMe,
            getDownloadToken,
            updateMe,
            updateMePassword
        }

        return MeService;

        function getMe() {
            return HttpService.get('/me');
        }

        function getDownloadToken() {
            return HttpService.get('/me/hash-authorization');
        }

        function updateMe(meData) {
            return HttpService.put('/me', meData);
        }

        function updateMePassword(mePasswordData) {
            return HttpService.put('/me/change-password', mePasswordData);
        }
    }
}());